<template>
  <div class="image-frame">
    <template v-if="frameUrl">
      <img class="image-frame__border"
           :src="frameUrl"
           :alt="frameAlt || `${frame} visual image`"
           aria-hidden="true">

      <div class="image-frame__hero-container"
           :class="classes">
        <picture v-if="image">
          <source :srcset="image.url">
          <img class="image-frame__hero"
               :width="image.width"
               :height="image.height"
               :src="`${image.url}${image.url.includes( '?' ) ? '&' : '?'}format=*`"
               :alt="image.alt">
        </picture>
      </div>
    </template>
    <template v-else>
      <picture v-if="image">
        <source :srcset="image.url">
        <img class="image-frame__image"
             :width="image.width"
             :height="image.height"
             :src="`${image.url}${image.url.includes( '?' ) ? '&' : '?'}format=*`"
             :alt="image.alt">
      </picture>
    </template>
  </div>
</template>

<script>
export default {
  name: "ImageFrame",
  props: {
    frame: {
      type: String,
      default: null,
    },
    frameAlt: {
      type: String,
      default: "",
    },
    image: {
      type: Object,
      default: null,
    },
  },
  computed: {
    borderName () {
      return this.frame ? this.frame.toLowerCase().trim() : null;
    },
    frameUrl () {
      let result = null;
      if ( this.borderName && this.borderName !== "none" ) {
        result = `/Assets/images/${this.borderName}_border.png`;
      }
      return result;
    },
    classes () {
      const result = [];

      if ( this.borderName && this.borderName !== "none" ) {
        result.push( `image-frame--${this.borderName}` );
      }

      return result;
    },
  },
};
</script>

<style lang="less" scoped>
.image-frame {
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &--laptop {
    top: 6%;
    left: 11.8%;
    right: 11.6%;
    bottom: 10.3%;
  }

  &--tablet {
    top: 6%;
    left: 7.5%;
    right: 5.9%;
    bottom: 7%;
  }
  &__border {
    width: 100%;
    position: relative;
    z-index: 100;
  }

  &__hero-container {
    background-color: #fff;
    position: absolute;
  }

  &__hero {
    position: relative;
    z-index: 99;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__image {
    display: block;
    max-width: 100%;
    height: auto;
  }
}
</style>
